<template>
  <div :class="bem.e('directory-title')">
    <div :class="bem.e('directory-title-container')">
      <ll-icon :class="bem.e('directory-icon')" icon-name="icon-list" />
      <span :class="bem.e('directory-text')">
        <slot name="title">目录</slot>
      </span>
    </div>
    <!-- 展开/收起 -->
    <ll-tooltip
      placement="bottom"
      :tip="isCollapseMenu ? '全部收起' : '全部展开'"
    >
      <template #title>
        <span>{{ isCollapseMenu ? '全部收起' : '全部展开' }}</span>
      </template>
      <ll-button
        type="text"
        :class="bem.e('directory-button')"
        @click="emits('collapseMenu')"
      >
        <template v-if="isCollapseMenu">
          <ll-icon :class="bem.e('directory-icon')" icon-name="icon-expand" />
        </template>
        <template v-else>
          <ll-icon :class="bem.e('directory-icon')" icon-name="icon-collapse" />
        </template>
      </ll-button>
    </ll-tooltip>
  </div>
</template>
<script lang="ts" setup>
import { createNamespace } from '@ll-plus/utils'
import {
  treeSelectDirectoryTitleEmits,
  treeSelectDirectoryTitleProps,
} from '../config'

defineOptions({ name: 'LlTreeSelectDirectoryTitle' })

defineProps(treeSelectDirectoryTitleProps)
const emits = defineEmits(treeSelectDirectoryTitleEmits)

const bem = createNamespace('tree-search')
</script>
